(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fp-product-carousel')) {
  customElements.define('fp-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fp-product-track');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-carousel-status]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.fp-carousel-controls').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    move(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= end - 2;
      const cards = [...this.track.children], edge = this.track.getBoundingClientRect().left;
      const index = cards.findIndex(card => card.getBoundingClientRect().right > edge + 5);
      if (this.status && cards.length) this.status.textContent = this.status.dataset.countLabel.replace('[current]', String(index + 1)).replace('[total]', String(cards.length));
    }
    disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
